import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";

export default function Clients() {
  const columns = [
    {
      id: "id",
      header: "id",
      accessorKey: "id",
      sortable: true,
      cell: ({ row }) => {
        const { first_name, last_name } = row.original;
        return <div>{first_name + " " + last_name}</div>
      }
    },
    {
      id: "company",
      header: "Company",
      accessorKey: "company_id.name",
    },
    {
      id: "mobile_number",
      header: "Contact No.",
      accessorKey: "mobile_number",
    },
    {
      id: "email",
      header: "Email",
      accessorKey: "email",
    },
  ];

  const fields = ["id", "first_name", "last_name", "mobile_number", "email", "company_id.name"];

  return (
    <div className="w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule={"create:*"}
          collection="clients"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Client</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <div className="flex-1 h-full">
        <List
          title="Clients"
          endPoint="clients"
          columns={columns}
          meta={{
            fields,
          }}
          href={(item) => `/crm/clients/${item.id}`}
          rowClassName="h-13"
        />
      </div>
    </div>
  );
}
